'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _order = require('../actions/order');

var _utils = require('../utils');

var _order_list = require('../components/order_list');

var _order_list2 = _interopRequireDefault(_order_list);

var _order_filter = require('../components/order_filter');

var _order_filter2 = _interopRequireDefault(_order_filter);

var _constants = require('../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Orders = _react2.default.createClass({
    displayName: 'Orders',

    propTypes: {
        orders: _react.PropTypes.object.isRequired,
        filter: _react.PropTypes.object.isRequired,
        dispatch: _react.PropTypes.func.isRequired
    },
    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
        if (!(0, _utils.filterEqual)(nextProps.filter, this.props.filter)) {
            var dispatch = nextProps.dispatch,
                filter = nextProps.filter;

            dispatch((0, _order.fetchOrdersIfNeeded)(filter));
        }
    },
    componentDidMount: function componentDidMount() {
        var _props = this.props,
            dispatch = _props.dispatch,
            filter = _props.filter;

        dispatch((0, _order.fetchOrdersIfNeeded)(filter));
    },
    onChange: function onChange(name, value) {

        this.props.dispatch((0, _order.filterOrders)(_defineProperty({}, name, value)));
    },
    onPageChange: function onPageChange(page) {
        // 页码改变
        var _props2 = this.props,
            dispatch = _props2.dispatch,
            filter = _props2.filter;

        dispatch((0, _order.fetchOrdersIfNeeded)(filter, page));
    },
    onChangeStatus: function onChangeStatus(orderId) {
        var _props3 = this.props,
            dispatch = _props3.dispatch,
            filter = _props3.filter;

        dispatch((0, _order.updateOrderIfNeeded)(orderId, filter));
    },
    render: function render() {
        return _react2.default.createElement(
            'div',
            { id: 'orders', className: 'clearfix' },
            _react2.default.createElement(_order_filter2.default, { status: _constants.ORDER_STATUS, onChange: this.onChange, filter: this.props.filter }),
            _react2.default.createElement(_order_list2.default, { orders: this.props.orders, onChange: this.onPageChange, handleClick: this.onChangeStatus })
        );
    }
});

var mapStateToProps = function mapStateToProps(store) {
    var _store$order = store.order,
        orders = _store$order.orders,
        filter = _store$order.filter;

    return {
        orders: orders,
        filter: filter
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Orders);


//////////////////
// WEBPACK FOOTER
// ./src/js/containers/orders.js
// module id = 1013
// module chunks = 0